import { getRequest } from '../../../utils'
import { PaymentMethod } from '../organization/types/paymentMethod'
import { SubscriptionInfo } from '../organization/types/subscriptionInfo'

export const fetchPaymentMethod = (organizationId: string): Promise<PaymentMethod> => {
  return getRequest(`/integrations/billing/${organizationId}/paymentmethod/default`)
}

export const fetchSubscriptionInfo = (organizationId: string): Promise<SubscriptionInfo> => {
  return getRequest(`/integrations/billing/${organizationId}/subscription`)
}
